/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useRef, useEffect, Fragment} from 'react';
import {Dialog, Transition} from '@headlessui/react';
import {toast} from 'react-toastify';
import {Link, useNavigate} from 'react-router-dom';
import {AiOutlineDelete} from 'react-icons/ai';
import {ContentHeader, Loader, DatePicker} from '@components';
import {Button, Modal, Spinner} from 'react-bootstrap';
import {format, intervalToDuration} from 'date-fns';
import {AlertTriangle, Clipboard} from 'lucide-react';
import {logoutUser} from '@store/reducers/auth';
import {useSelector, useDispatch} from 'react-redux';
import Pagination from '../../components/pagination/index';
import {
  getAllLeaves,
  deleteLeave,
  leaveUpdate,
  getLeaveSummary
} from '../../services/leaves';
import {getAllUserNames} from '../../services/auth';
import handleStatus from '../../utils/ajax';
import {LeaveInfoContainer} from './leaveInfoComponent';
import {calculateBusinessDays} from '../../utils/leaveDateCalculation';
import 'react-toastify/dist/ReactToastify.css';
// Make sure to bind modal to your app element (for accessibility)

// import Modal from 'react-modal';
function DeletePopup({handleClose, id, fetchProject}: any) {
  const delLeave = async () => {
    const resp = await deleteLeave(id);
    if (resp && !resp?.data?.ok) {
      toast.warn(resp?.data?.message || 'Error while deleting leave');
      handleClose();
      return;
    }
    toast.success(resp?.data?.message || 'Leave has been deleted');
    fetchProject({});
    handleClose();
  };
  return (
    <Modal
      show
      onHide={handleClose}
      centered
      dialogClassName="custom-modal-width"
    >
      <>
        <Modal.Header>
          <Modal.Title>Delete leave</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{maxHeight: '400px', overflowY: 'auto'}}>
          <p style={{textAlign: 'center'}}>
            <h2>Are you sure you want to delete the current leave request?</h2>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={delLeave}>
            Yes
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
        </Modal.Footer>
      </>
    </Modal>
  );
}

function ModalPopup({loginUser, leave, handleClose}: any) {
  console.log(loginUser, 'login user *******************', leave);
  const [paidLeave, setPaidLeave] = useState<number>(0);
  const [unPaidLeave, setUnPaidLeave] = useState<number>(0);
  const [error, setError] = useState<string | null>(null);
  const {_id: leaveId} = leave;
  const userRole: any = loginUser?.data?.permissions[0];
  console.log(
    userRole,
    'user role ',
    leave.userId.permissions[0],
    'dfjsdfksksdfjdfksdj'
  );
  const totalAppliedLeaves =
    leave.leave_duration && leave.leave_duration.toLowerCase() === 'half day'
      ? 0.5
      : calculateBusinessDays(leave.leave_start_date, leave.leave_end_date);

  const validateLeaveInput = (value: string | number) => {
    const numValue = Number(value);
    if (Number.isNaN(numValue) || numValue < 0) {
      return {ok: false, message: 'Leave value cannot be less than 0.'};
    }
    return {ok: true, message: ''};
  };

  const handlePaidLeaveChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e?.target?.value;
    const numValue = Number(value);

    if (!validateLeaveInput(value)?.ok) {
      setError(validateLeaveInput(value)?.message);
      return;
    }

    if (numValue > totalAppliedLeaves) {
      setError(
        `Paid leaves cann't exceed total applied leave ${totalAppliedLeaves}`
      );
      return;
    }

    const remainingUnpaidLeave = totalAppliedLeaves - numValue;
    setPaidLeave(numValue);
    setUnPaidLeave(remainingUnpaidLeave);
    setError(null);
  };

  const updateLeaveStatus = async (
    leave: any,
    status: {
      approved: boolean;
      declined: boolean;
      process: boolean;
      paidLeave: number;
      unPaidLeave: number;
    },
    successMessage: string
  ) => {
    try {
      const response = await leaveUpdate(status, leaveId);
      handleClose();
      if (!response?.data?.ok) {
        toast.warn(response?.data?.message || 'Error while updating leaves');
        return;
      }
      Object.assign(leave, status);
      toast(response?.data?.message || successMessage);
    } catch (error) {
      toast.warn('An unexpected error occurred while updating leave.');
      console.error('Leave update error:', error);
    }
  };

  const approveLeave = async ({leave}: any) => {
    console.log(paidLeave, unPaidLeave);

    if (error) {
      toast.error(
        'Enter paid leave value 0 and less than total applied leaves.'
      );
      return;
    }

    if (!paidLeave && !unPaidLeave) {
      toast.error("Paid leave cann't be empty.");
      return;
    }

    // Allow only 0.5 (half-day) and whole numbers (0, 1, 2, etc.)
    if (paidLeave !== 0.5 && !Number.isInteger(paidLeave)) {
      toast.error(
        'Paid leave should be 0.5 (half-day) or a whole number (1, 2, etc.).'
      );
      return;
    }

    await updateLeaveStatus(
      leave,
      {approved: true, declined: false, process: false, paidLeave, unPaidLeave},
      'Leave approved successfully'
    );
  };

  const declineLeave = async ({leave}: any) => {
    await updateLeaveStatus(
      leave,
      {
        approved: false,
        declined: true,
        process: false,
        paidLeave: 0,
        unPaidLeave: 0
      },
      'Leave declined successfully'
    );
  };

  return (
    <Modal
      show
      onHide={handleClose}
      centered
      dialogClassName="custom-modal-width"
    >
      <>
        <Modal.Header>
          <Modal.Title>Leave</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{maxHeight: '400px', overflowY: 'auto'}}>
          <div>
            <div className="modal-field">
              <span className="field-label">Name:</span>
              <span className="field-value">{leave.userId.name}</span>
            </div>
            <div className="modal-field">
              <span className="field-label"> Leave Reason :</span>
              <span className="field-value">{leave.reason}</span>
            </div>
            <div className="modal-field">
              <span className="field-label"> Leave Type:</span>
              <span className="field-value">{leave.leave_type}</span>
            </div>
            <div className="modal-field">
              <span className="field-label"> Leave Duration:</span>
              <span className="field-value">{leave.leave_duration}</span>
            </div>
            <div className="modal-field">
              <span className="field-label"> Total Leaves:</span>
              <span className="field-value">
                {leave.leave_duration &&
                leave.leave_duration.toLowerCase() === 'half day'
                  ? leave.leave_duration.toLowerCase()
                  : calculateBusinessDays(
                      leave.leave_start_date,
                      leave.leave_end_date
                    )}
              </span>
            </div>
            {leave?.userId?.permissions[0] !== userRole &&
              (!leave?.approved && !leave?.declined ? (
                <>
                  <div className="modal-field">
                    <span className="field-label">Paid Leave:</span>
                    <input
                      type="number"
                      name="paidLeave"
                      value={paidLeave}
                      className="field-value"
                      onChange={handlePaidLeaveChange}
                      required
                    />
                  </div>

                  <div className="modal-field">
                    <span className="field-label">Unpaid Leave:</span>
                    <p className="field-value">{unPaidLeave}</p>
                  </div>

                  {error && <p style={{color: 'red'}}>{error}</p>}
                </>
              ) : (
                <>
                  <div className="modal-field">
                    <span className="field-label">Paid Leave:</span>
                    <span className="field-value">{leave?.paidLeave || 0}</span>
                  </div>

                  <div className="modal-field">
                    <span className="field-label">Unpaid Leave:</span>
                    <span className="field-value">
                      {leave?.unPaidLeave || 0}
                    </span>
                  </div>
                </>
              ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {leave?.userId?._id !== loginUser?.data?._id &&
            !leave?.approved &&
            !leave?.declined && (
              <>
                <Button variant="success" onClick={() => approveLeave({leave})}>
                  Approve
                </Button>
                <Button
                  variant="danger"
                  onClick={() => declineLeave({loginUser, leave})}
                >
                  Deny
                </Button>
              </>
            )}
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </>
    </Modal>
  );
}

// const ShowPrompt = ({userId}) => {
//   const [isCopied, setIsCopied] = useState(false);
//   const [leaveData, setLeaveData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   // Fetch leave data when userId changes
//   // useEffect(() => {
//   //   if (userId) {
//   //     fetchLeaveData();
//   //   }
//   // }, [userId]);

//   const fetchLeaveData = async () => {
//     if (!userId) {
//       alert('No user ID found. Please select a user ID.');
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await getLeaveSummary({userId});
//       console.log(response?.data, '**************response?.data?.data');

//       if (response?.data?.ok) {
//         setLeaveData(response.data.data);
//         const {leaveRules, year, joiningDate, currentDate, ...mappedLeaveData} =
//           response.data.data;
//         console.log(mappedLeaveData, 'sdfdfjsdkfsdjfsdkjfsdll');
//         // const summary = `${leaveRules} \n ${JSON.stringify(mappedLeaveData)}`;
//         // Format sections
//         const generalInfo = `📅 General Info:
//         - Year: ${year}
//         - Joining Date: ${joiningDate || 'N/A'}
//         - Current Date: ${currentDate || 'N/A'}`;

//         const formattedLeaves =
//           mappedLeaveData?.leaves
//             ?.map(
//               (leave: any, index: number) =>
//                 `${index + 1}. ${leave.date} - ${leave.days} day(s) (${
//                   leave.type
//                 })`
//             )
//             .join('\n') || 'No leaves taken';

//         const leaveDetails = `🗓️ Leave Details:
//         ${formattedLeaves}`;

//         const rules = `📋 Leave Rules:\n${leaveRules}`;

//         // Final summary string
//         const summary = `${rules}\n\n${generalInfo}\n}\n\n${leaveDetails}`;

//         // Show prompt (alert) with the fetched data
//         alert(`Leave Data Fetched Successfully!\n\n${summary}`);
//         // Copy to clipboard automatically
//         await handleCopy(summary);
//       } else {
//         alert('No valid leave data received');
//       }
//     } catch (err: any) {
//       console.error(err, 'error**************');
//       alert(err?.message || 'Failed to fetch leave data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCopy = async (text: string) => {
//     try {
//       await navigator.clipboard.writeText(text);
//       setIsCopied(true);
//       setTimeout(() => setIsCopied(false), 2000);
//     } catch (err) {
//       console.error('Failed to copy:', err);
//       alert('Failed to copy to clipboard');
//     }
//   };

//   return (
//     <>
//       <div className="col-md-1">
//         <Button onClick={fetchLeaveData} variant="primary" disabled={loading}>
//           {loading ? 'Loading...' : <AlertTriangle className="w-3 h-5" />}
//         </Button>
//       </div>

//       {/* Show "Copied!" feedback if successful */}
//       {isCopied && (
//         <div className="text-success mt-2">✓ Copied to clipboard!</div>
//       )}
//     </>
//   );
// };

export const ShowPrompt = ({userId}) => {
  const [isCopied, setIsCopied] = useState(false);
  const [leaveData, setLeaveData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [summary, setSummary] = useState('');

  const fetchLeaveData = async () => {
    if (!userId) {
      alert('No user ID found. Please select a user ID.');
      return;
    }
    setLoading(true);
    try {
      const response = await getLeaveSummary({userId});
      if (response?.data?.ok) {
        setLeaveData(response.data.data);
        const {leaveRules, year, joiningDate, currentDate, ...mappedLeaveData} =
          response.data.data;

        const generalInfo = `📅 General Info:
- Year: ${year}
- Joining Date: ${joiningDate || 'N/A'}
- Current Date: ${currentDate || 'N/A'}`;

        const formattedLeaves =
          mappedLeaveData?.leaves
            ?.map(
              (leave: any, index: number) =>
                `${index + 1}. ${leave.date} - ${leave.days} day(s) (${
                  leave.type
                })`
            )
            .join('\n') || 'No leaves taken';

        const leaveDetails = `🗓️ Leave Details:
${formattedLeaves}`;

        const rules = `📋 Leave Rules:\n${leaveRules}`;

        const finalSummary = `${rules}\n\n${generalInfo}\n\n${leaveDetails}`;
        setSummary(finalSummary);
        setModalOpen(true);
      } else {
        alert('No valid leave data received');
      }
    } catch (err: any) {
      console.error(err);
      alert(err?.message || 'Failed to fetch leave data');
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(summary);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      alert('Failed to copy to clipboard');
    }
  };

  return (
    <>
      <div className="col-md-1">
        <Button onClick={fetchLeaveData} variant="primary" disabled={loading}>
          {loading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <AlertTriangle />
          )}
        </Button>
      </div>

      <Modal show={modalOpen} onHide={() => setModalOpen(false)} size="lg">
        <Modal.Header>
          <Modal.Title>Leave Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre style={{whiteSpace: 'pre-wrap'}}>{summary}</pre>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleCopy}>
            <Clipboard className="me-2" size={16} />
            {isCopied ? 'Copied!' : 'Copy to Clipboard'}
          </Button>
          <Button variant="secondary" onClick={() => setModalOpen(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const Status = ({leave}: any) => {
  if (leave.approved) {
    return <span className="badge badge-success">Approved</span>;
  }
  if (leave.declined) {
    return <span className="badge badge-danger">Declined</span>;
  }
  return <span className="badge badge-warning">Pending</span>;
};
// timestamp to date

const AllLeaves = () => {
  const loginUser = useSelector((state: any) => state.auth.currentUser);
  const [startDate, setStartDate] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteLeave, setDeleteLeave] = useState('');
  const [leave, setLeave] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [leaves, setLeaves] = useState([]);
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState('');
  const datePickerRef = React.useRef<{resetDatePicker: () => void} | null>(
    null
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(10);
  const [leaveDetails, setLeaveDetails] = useState(null) as any;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getAll = async (query: any) => {
    setShowLoader(true);
    const resp = await getAllLeaves(query);
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
    setShowLoader(false);
    if (resp.data.ok === true) {
      if (resp.data.data) {
        setLeaves(resp.data.data);
        setTotalRecords(resp.data.totalRecords);
        if (resp.data.leaveDetails) {
          setLeaveDetails(resp.data.leaveDetails);
        }
      }
    }
  };

  const handleCustomDateChange = ({startDate, endDate}: any) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };
  console.log(leaveDetails, 'leaveDetails****************');
  const filter = () => {
    getAll({startDate, endDate, userId: user});
  };

  const clear = () => {
    if (datePickerRef.current) {
      datePickerRef.current.resetDatePicker();
    }
    setUser('');
    setStartDate(0);
    setEndDate(0);
    setLeaveDetails(null);
    getAll({});
  };

  const onChange = (e: any) => {
    let value = e?.target?.value;
    if (value === 'Name') {
      value = null;
    }
    setUser(value);
  };
  // const getAllUsersLeaves = async () => {
  //   setShowLoader(true);
  //   const resp = await getAllLeaves({});
  //   handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
  //   setShowLoader(false);
  //   if (resp.data.ok) {
  //     setLeaves(resp.data.data);
  //   }
  // };

  const getAllUsers = async () => {
    const resp = await getAllUserNames();
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
    setUsers(resp.data.data);
  };
  useEffect(() => {
    getAllUsers();
    getAll({});
  }, []);

  const showLeave = (leave: any) => {
    setShowPopup(true);
    setLeave(leave);
  };

  const handleClose = () => {
    setShowPopup(false);
    setLeave(null);
  };

  // const daysDiff = (startDate, endDate) => {
  //   const diff = intervalToDuration({
  //     start: new Date(startDate),
  //     end: new Date(endDate)
  //   });

  //   const {days, months} = diff;

  //   if (months === undefined || months === 0) {
  //     return days === 0 ? days + 1 + ' day' : days + 1 + ' days';
  //   }

  //   if (months > 0 && days === 0) {
  //     return months === 1 ? months + ' month' : months + ' months';
  //   }

  //   if (months > 0 && days > 0) {
  //     const month = months === 1 ? 'month' : 'months';
  //     const day = days === 1 ? 'day' : 'days';
  //     return `${months} ${month}, ${days} ${day} `;
  //   }
  // };

  const paginate = (pageno: React.SetStateAction<number>) => {
    getAll({
      startDate,
      endDate,
      userId: user,
      pageNo: pageno
    });
    setCurrentPage(pageno);
  };

  const showDeletePopupFn = ({_id: id}: any) => {
    setShowDeletePopup(true);
    setDeleteLeave(id);
  };

  const handleCloseDeletePopup = () => {
    setShowDeletePopup(false);
  };
  // console.log(leaveDetails, 'sdfsdklfdfsdjfdskfsjl');
  return (
    <div>
      <ContentHeader title="All Leaves" />
      {showPopup && (
        <ModalPopup
          loginUser={loginUser}
          handleClose={handleClose}
          leave={leave}
        />
      )}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">All Employees Leaves</h3>
            </div>
            <div className="card-body">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-end flex-wrap">
                    <div className="col-md-3">
                      <select
                        onChange={onChange}
                        value={user}
                        className="form-control"
                      >
                        <option selected>Name</option>
                        {users.map(({_id: id, name}) => (
                          <option key={id} value={id}>
                            {name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <DatePicker
                        ref={datePickerRef}
                        onSelect={handleCustomDateChange}
                      />
                    </div>

                    <div className="col-md-1">
                      <Button onClick={filter} variant="primary">
                        Search
                      </Button>
                    </div>

                    <div className="col-md-1">
                      <Button onClick={clear} variant="primary">
                        Reset
                      </Button>
                    </div>

                    <ShowPrompt userId={user} />
                  </div>
                  {leaveDetails ? (
                    <LeaveInfoContainer
                      totalLeaves={leaveDetails?.totalLeaves}
                      appliedLeaves={leaveDetails?.appliedLeaves}
                      remainingLeaves={leaveDetails?.remainingLeaves}
                      isLeaveExceeded={leaveDetails?.isLeaveExceeded}
                      totalPaidLeave={leaveDetails?.totalPaidLeave}
                      totalUnpaidLeave={leaveDetails?.totalUnpaidLeave}
                    />
                  ) : (
                    ''
                  )}

                  <div
                    style={{marginTop: '20px'}}
                    className="card-body table-responsive p-0"
                  >
                    {showLoader ? (
                      <Loader title="Daily" />
                    ) : (
                      <table className="table table-hover text-nowrap">
                        <thead>
                          <tr>
                            <th>Username</th>
                            <th style={{textAlign: 'center'}}>Applied on</th>
                            <th style={{textAlign: 'center'}}>Duration</th>
                            <th style={{textAlign: 'center'}}>From</th>
                            <th style={{textAlign: 'center'}}>To</th>
                            <th style={{textAlign: 'center'}}>Status</th>
                            <th style={{textAlign: 'right'}}>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {leaves.length > 0 &&
                            leaves.map((leave: any) => {
                              return (
                                <tr>
                                  <td>{leave.userId.name}</td>
                                  <td style={{textAlign: 'center'}}>
                                    {' '}
                                    {format(
                                      new Date(leave.created_At),
                                      'dd/MM/yyyy'
                                    )}
                                  </td>
                                  <td style={{textAlign: 'center'}}>
                                    {leave.leave_duration &&
                                    leave.leave_duration.toLowerCase() ===
                                      'half day'
                                      ? leave.leave_duration.toLowerCase()
                                      : calculateBusinessDays(
                                          leave.leave_start_date,
                                          leave.leave_end_date
                                        )}
                                  </td>
                                  <td style={{textAlign: 'center'}}>
                                    {format(
                                      new Date(leave.leave_start_date),
                                      'dd/MM/yyyy'
                                    )}
                                  </td>
                                  <td style={{textAlign: 'center'}}>
                                    {format(
                                      new Date(leave.leave_end_date),
                                      'dd/MM/yyyy'
                                    )}
                                  </td>
                                  <td style={{textAlign: 'center'}}>
                                    <Status leave={leave} />
                                  </td>

                                  <td>
                                    <div className="d-flex justify-content-end project-actions">
                                      {/* <Link
                                        to=""
                                        className="btn btn-primary btn-sm"
                                        onClick={() => showLeave(leave)}
                                      >
                                        <i className="fas fa-eye" />
                                      </Link> */}

                                      {/* <ShowPrompt /> */}

                                      <Link
                                        to=""
                                        className="btn btn-primary btn-sm"
                                        onClick={() => showLeave(leave)}
                                      >
                                        <i className="fas fa-eye" />
                                      </Link>

                                      {leave?.userId?._id !==
                                      loginUser?.data?._id ? (
                                        <Link
                                          to=""
                                          className="btn btn-primary btn-sm bg-danger border-danger"
                                          onClick={() =>
                                            showDeletePopupFn(leave)
                                          }
                                        >
                                          <AiOutlineDelete />
                                        </Link>
                                      ) : null}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {showDeletePopup && (
              <DeletePopup
                handleClose={handleCloseDeletePopup}
                id={deleteLeave}
                fetchProject={getAll}
              />
            )}
            <Pagination
              postsPerPage={postPerPage}
              totalPosts={totalRecords}
              paginate={paginate}
              currentPage={currentPage}
            />
          </div>
        </div>

        <div className="modal fade" id="modal-default">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Default Modal</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>One fine body&hellip;</p>
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AllLeaves;
